import { useEffect, useState } from "react";
import api from "../../../../../../services/api";

/**
 * Busca as permissões disponíveis para um cliente do portal: as globais do
 * sistema (ADM/TÉCNICO) + as criadas pelo próprio cliente.
 *
 * As permissões do portal são escopadas por cliente, então a lista precisa ser
 * recarregada sempre que o cliente selecionado mudar.
 */
export default function usePermissoesDoCliente({
  clienteId,
  enabled = true,
  apiInstance = api,
  url = "/interno/getPermissoesCliente",
}) {
  const [permissoes, setPermissoes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !clienteId) {
      setPermissoes([]);
      return;
    }

    let ativo = true;

    const buscarPermissoes = async () => {
      setLoading(true);
      try {
        const response = await apiInstance.get(url, {
          params: { clienteId },
        });
        if (ativo) setPermissoes(response?.data || []);
      } catch (error) {
        console.error("Erro ao buscar permissões do cliente", error);
        if (ativo) setPermissoes([]);
      } finally {
        if (ativo) setLoading(false);
      }
    };

    buscarPermissoes();

    return () => {
      ativo = false;
    };
  }, [clienteId, enabled, url]);

  return { permissoes, loading };
}
